import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/components/landing/Navbar";
import Reveal from "@/components/landing/Reveal";

export default function Closing() {
  return (
    <section id="abschluss" data-testid="closing-section" className="relative overflow-hidden border-t border-white/10 px-6 py-24 lg:px-16 lg:py-36">
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.05] [background-image:linear-gradient(#F5B301_1px,transparent_1px),linear-gradient(90deg,#F5B301_1px,transparent_1px)] [background-size:52px_52px]" />
      <div className="relative z-10 mx-auto max-w-4xl text-center">
        <Reveal>
          <h2 className="font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter sm:text-6xl lg:text-7xl">
            Sie prüfen –<br /><span className="text-[#F5B301]">wir erfassen.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-8 max-w-2xl font-tac text-sm leading-relaxed text-[#A1A1AA]">
            DROPS TFR unterstützt Ingenieure, Betreiber, Unternehmen und öffentliche Auftraggeber bei der
            technischen Datenerfassung schwer zugänglicher Bauwerke und Anlagen.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mx-auto mt-6 max-w-2xl font-tac text-[11px] uppercase tracking-[0.25em] text-white/50">
            Technische Spezialinspektionen · Digitale Datenerfassung · 360° · RTK · Photogrammetrie · 3D · Technische Soforterfassung
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <button
            type="button"
            data-testid="closing-cta"
            onClick={() => scrollToId("#kontakt")}
            className="group mt-12 inline-flex items-center gap-2 bg-[#F5B301] px-10 py-5 font-tac text-xs font-bold tracking-[0.25em] text-black transition-transform duration-300 hover:scale-[1.03]"
          >
            KONTAKT AUFNEHMEN <ArrowUpRight className="h-4 w-4" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
